<template>
  <div>
    <transition name="fade" v-if="!loaderFinished">
      <SiteLoader key="1" @setLoaderFinished="setLoaderFinished" :barLoader="false" />
    </transition>
    <div v-else>
      <transition name="fade">
        <div id="main-container">
          <TopNav />
          <router-view />
        </div>
      </transition>
      <Footer />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiteLoader from "@/components/global/SiteLoader";
import TopNav from "@/components/global/TopNav";
export default {
  name: "Layout",
  components: {
    SiteLoader,
    TopNav
  },
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      loaderFinished: false
    };
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", () => {
      this.setScreenWidth(window.innerWidth);
    });
  },
  methods: {
    setLoaderFinished() {
      this.loaderFinished = true;
    },
    ...mapActions(["setScreenWidth"])
  }
};
</script>

<style lang="scss" scoped>
#main-container {
}
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap");

body {
  overflow: initial !important;
  font-family: "Montserrat", sans-serif !important;
}

button {
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  margin: 5px !important;
  &.green {
    background-color: #2ec693;
    color: #fff;
  }
  &.red {
    background-color: #ff6458;
    color: #fff;
  }
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-center {
  justify-content: center;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-grow {
  flex-grow: 1;
}
</style>